/**
 * Valeurs = identifiants `__component` Strapi (alignés sur les `case` du rendu des blocs).
 */
export enum BlockNameEnum {
  HERO_SECTION = 'block.hero-section',
  TEXT_BUBBLES = 'block.bulles-de-textes',
  LOGO_CLIENTS = 'block.logo-clients',
  TEXT_MEDIA = 'block.text-media',
  TEXT_ACCORDION = 'block.text-accordion',
  NUMBERED_LIST = 'block.numbered-list',
  FAQ = 'block.faq',
  ACTIVITIES = 'block.activities',
  CLIENT_OVERVIEW = 'block.client-overview',
  FRAMED_PICTURES = 'block.framed-pictures',
  CUSTOMER_CASES = 'block.customer-cases',
  DOUDOU_LIST = 'block.doudou-list',
  MOCKUP = 'block.mockup',
  OFFERS = 'block.offers',
  QUOTATION = 'block.quotation',
  PRESS = 'block.press',
  WYSIWYG = 'block.wysiwyg',
  JOB_DETAILS = 'block.job-details',
  FORM_OFFER = 'block.form-offer',
  FORM_JOB_APPLICATION = 'block.form-job-application',
  DUAL_IMAGE_TEXT_SECTION = 'block.deux-images-texte-centrale',
  ILLUSTRATION = 'block.illustration',
}

export const getBlockNameValues = () => Object.values(BlockNameEnum) as [string, ...string[]];
